import React, { useState, useEffect } from "react";
import {
  ArrowLongLeftIcon,
  ArrowLongRightIcon,
} from "@heroicons/react/24/outline";
import axios from "axios";
import Cookies from "js-cookie";

export default function AllTawkils() {
  const [tawkilsAd, setTawkilsAd] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [searchTerm, setSearchTerm] = useState("");

  const itemsPerPageAd = 5;

  let totalPagesAd = 0;
  if (tawkilsAd) {
    totalPagesAd = Math.ceil(tawkilsAd.length / itemsPerPageAd);
  }

  let currentTawkilsAd = [];
  if (tawkilsAd) {
    const indexOfLastItem = currentPage * itemsPerPageAd;
    const indexOfFirstItem = indexOfLastItem - itemsPerPageAd;
    currentTawkilsAd = tawkilsAd.slice(indexOfFirstItem, indexOfLastItem);
  }

  const nextPageAd = () => {
    setCurrentPage((prevPage) => Math.min(prevPage + 1, totalPagesAd));
  };

  const prevPageAd = () => {
    setCurrentPage((prevPage) => Math.max(prevPage - 1, 1));
  };

  // Accept tawkil admin
  const handleAccept = async (tawkilId) => {
    try {
      const token = Cookies.get("token");
      await axios.put(
        `${process.env.REACT_APP_ADDRESS}/tawkil/accept-tawkil/${tawkilId}`,
        null,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      fetchTawkilsAdmin();
    } catch (error) {
      console.error("Error accepting tawkil:", error);
    }
  };

  const handleRefuse = async (tawkilId) => {
    try {
      const token = Cookies.get("token");
      await axios.put(
        `${process.env.REACT_APP_ADDRESS}/tawkil/refuse-tawkil/${tawkilId}`,
        null,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      fetchTawkilsAdmin();
    } catch (error) {
      console.error("Error refusing tawkil:", error);
    }
  };

  const fetchTawkilsAdmin = async () => {
    try {
      const token = Cookies.get("token");
      const response = await axios.get(
        `${process.env.REACT_APP_ADDRESS}/tawkil/tawkil-request?search=${searchTerm}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      console.log(response.data);
      setTawkilsAd(response.data);
    } catch (error) {
      console.error("Error fetching tawkils:", error);
    }
  };

  useEffect(() => {
    if (searchTerm.length === 0 || searchTerm.length > 2) fetchTawkilsAdmin();
  }, [searchTerm]);

  return (
    <>
      <div className="px-4 sm:px-6 lg:px-8">
        <div className="sm:flex sm:items-center">
          <div className="sm:flex-auto">
            <h1 className="text-2xl font-semibold leading-6 text-gray-900 pb-4">
              Admin Dashboard
            </h1>
            <h1 className="text-base font-semibold leading-6 text-gray-900">
              Tawkil Requests: This section displays a list of pending Tawkil requests.
            </h1>
          </div>
        </div>
        <div className="mt-8 flow-root">
          <div className="-mx-4 -my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
            <div className="inline-block min-w-full py-2 align-middle sm:px-6 lg:px-8">
              <div className="search-container w-1/4 float-right">
                <div className="relative">
                  <input
                    type="search"
                    className="relative m-0 block w-full rounded border border-solid border-neutral-200 bg-transparent bg-clip-padding px-3 py-[0.25rem] text-base font-normal leading-[1.6] text-surface outline-none transition duration-200 ease-in-out placeholder:text-neutral-500 focus:border-pink focus:shadow-inset focus:outline-none motion-reduce:transition-none dark:border-white/10 text-black dark:placeholder:text-neutral-200 dark:autofill:shadow-autofill"
                    placeholder="Search tawkils by name..."
                    onChange={(event) => {
                      setSearchTerm(event.target.value);
                    }}
                  />
                </div>
              </div>
              <table className="min-w-full divide-y divide-gray-300">
                <thead>
                  <tr>
                    <th
                      scope="col"
                      className="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-0"
                    >
                      Name
                    </th>
                    <th
                      scope="col"
                      className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
                    >
                      National ID
                    </th>
                    <th
                      scope="col"
                      className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
                    >
                      Phone Number
                    </th>
                    <th
                      scope="col"
                      className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
                    >
                      Status
                    </th>
                    <th
                      scope="col"
                      className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
                    >
                      Action
                    </th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-gray-200">
                  {currentTawkilsAd.map((tawkil) => (
                    <tr key={tawkil._id}>
                      <td className="whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-gray-900 sm:pl-0">
                        {tawkil.firstName} {tawkil.lastName}
                      </td>
                      <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
                        {tawkil.nationalId}
                      </td>
                      <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
                        {tawkil.phoneNumber}
                      </td>
                      <td
                        style={{
                          color:
                            tawkil.Status === "Pending"
                              ? "gold"
                              : tawkil.Status === "Refused"
                              ? "red"
                              : "green",
                        }}
                      >
                        {tawkil.Status}
                      </td>
                      <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
                        <button
                          onClick={() => handleAccept(tawkil._id)}
                          style={{
                            backgroundColor: "#00cc44",
                            color: "white",
                            border: "none",
                            padding: "8px 16px",
                            borderRadius: "4px",
                            margin: "4px",
                          }}
                        >
                          Accept
                        </button>
                        <button
                          onClick={() => handleRefuse(tawkil._id)}
                          style={{
                            backgroundColor: "#ff3333",
                            color: "white",
                            border: "none",
                            padding: "8px 16px",
                            borderRadius: "4px",
                            margin: "4px",
                          }}
                        >
                          Refuse
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>

              <nav className="flex items-center justify-between border-t border-gray-200 px-4 sm:px-0">
                <div className="-mt-px flex w-0 flex-1">
                  <button
                    onClick={prevPageAd}
                    disabled={currentPage === 1}
                    className={`inline-flex items-center border-t-2 border-transparent pr-1 pt-4 text-sm font-medium ${
                      currentPage === 1
                        ? "text-gray-300 pointer-events-none"
                        : "text-gray-500 hover:border-gray-300 hover:text-gray-700"
                    }`}
                  >
                    <ArrowLongLeftIcon
                      className="mr-3 h-5 w-5 text-gray-400"
                      aria-hidden="true"
                    />
                    Previous
                  </button>
                </div>
                <div className="hidden md:-mt-px md:flex">
                  {/* Page numbers */}
                  {Array.from({ length: totalPagesAd }).map((_, i) => (
                    <a
                      key={i + 1}
                      href="#"
                      onClick={() => setCurrentPage(i + 1)}
                      className={`inline-flex items-center border-t-2 px-4 pt-4 text-sm font-medium ${
                        currentPage === i + 1
                          ? "border-pink-500 text-pink-600"
                          : "border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700"
                      }`}
                    >
                      {i + 1}
                    </a>
                  ))}
                </div>
                <div className="-mt-px flex w-0 flex-1 justify-end">
                  <button
                    onClick={nextPageAd}
                    disabled={currentPage === totalPagesAd}
                    className={`inline-flex items-center border-t-2 border-transparent pl-1 pt-4 text-sm font-medium ${
                      currentPage === totalPagesAd
                        ? "text-gray-300 pointer-events-none"
                        : "text-gray-500 hover:border-gray-300 hover:text-gray-700"
                    }`}
                  >
                    Next
                    <ArrowLongRightIcon
                      className="ml-3 h-5 w-5 text-gray-400"
                      aria-hidden="true"
                    />
                  </button>
                </div>
              </nav>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
